import './overrides/event-ga'
import EventTrackerManager from './event-tracker-manager'

EventTrackerManager._init()
